import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface TBeamIconProps {
  size?: number;
  color?: string;
}

const TBeamIcon: React.FC<TBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-tbeam">
    {
      <path d="M11.556 21.102c0.012 0 0.022-0.010 0.022-0.022v-15.635c0-0.394-0.319-0.713-0.713-0.713h-4.089c-0.005 0-0.009-0.004-0.009-0.009v-0.906c0-0.005 0.004-0.009 0.009-0.009h10.335c0.065 0 0.117 0.053 0.117 0.117v0.797s0.005 0 0 0h-3.96c-0.426 0-0.775 0.349-0.775 0.775v15.586z"></path>
    }  </SvgIcon>
);

export default TBeamIcon;
